import { MultiSlideCarousel } from "components/carousel/multiSlide";
import Image from "components/imageNew/image";

export default function Carousel({ slides }) {
  if (!slides.length) return null;

  const slidesMulti = slides.map((item, i) => {
    const { image } = item;
    return {
      widths: [570, 570, 320],
      component: (
        <Image
          key={i}
          src={image?.url}
          alt={image?.alt}
          height={image?.height}
          width={image?.width}
          blurDataURL={image?.blurUpThumb}
          className="pointer-events-none mx-auto h-100 min-h-[214px] w-[320px] object-cover object-center md:min-h-[381px] md:w-[570px]"
          sizes="320px"
        />
      ),
    };
  });

  return (
    <div className="-mx-5 mb-[70px] max-h-fit lg:mx-0">
      <MultiSlideCarousel
        autoplay={false}
        belowSlides="prevNext"
        slides={slidesMulti}
        containerClasses="h-[214px] md:h-[381px]"
        slideClasses="h-100"
        paginationContainerClassesOverride="mt-[20px] md:mt-[30px] flex justify-center"
        responsiveGap={[20]}
        onlyCenterInteractive={true}
      />
    </div>
  );
}
